module.exports = __webpack_public_path__ + "static/media/fire.250fd740.gif";